import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../../redux/actions";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import PreviewTable from "../../../components/PreviewTable";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { TextArea } = Input;

function FundsTransfer(props) {
  const { userData, rightBtn } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [vaultStatus, setVaultStatus] = useState("O");
  const [branchCode, setBranchCode] = useState();
  const [searchData, setSearchData] = useState(null);
  const [denominationEntries, setDenominationEntries] = useState([]);
  const searchParam = Form.useWatch("accountNo", form);

  const dataSections = [
    {
      name: "Name",
      labelValue: searchData?.name || "----",
    },
    {
      name: "Branch",
      labelValue: searchData?.branch || "----",
    },
    {
      name: "From Account",
      labelValue: searchData?.fromAccount || "----",
    },
    {
      name: "From Account Type",
      labelValue: searchData?.fromAccountType || "----",
    },
    {
      name: "Currency",
      labelValue: searchData?.currency || "----",
    },
  ];

  const branchOptions = [
    { value: "br001", label: "Head Office - Lagos" },
    { value: "br002", label: "Abuja Branch" },
    { value: "br003", label: "Port Harcourt Branch" },
    { value: "br004", label: "Ibadan Branch" },
    { value: "br005", label: "Kano Branch" },
  ];

  const accountTypeOptions = [
    { value: "savings", label: "Savings Account" },
    { value: "current", label: "Current Account" },
    { value: "fixed", label: "Fixed Deposit" },
    { value: "call", label: "Call Account" },
    { value: "corporate", label: "Corporate Account" },
  ];

  const paymentTypeOptions = [
    { value: "cash", label: "Cash" },
    { value: "transfer", label: "Bank Transfer" },
    { value: "cheque", label: "Cheque" },
    { value: "pos", label: "POS Terminal" },
    { value: "mobile", label: "Mobile Money" },
  ];

  const accountOptions = [
    { value: "acc001", label: "0001234567 - John Doe" },
    { value: "acc002", label: "0002345678 - Jane Smith" },
    { value: "acc003", label: "0003456789 - ABC Corp" },
    { value: "acc004", label: "0004567890 - Mike Johnson" },
    { value: "acc005", label: "0005678901 - Sarah Williams" },
  ];

  useEffect(() => {
    getPaymentTypes();
    form.setFieldValue("date", dayjs());
    setLoading(false);
  }, []);

  const getTemplate = (res) => {
    const params = {
      fromAccountId: res.id,
      fromAccountType: res.clientId,
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.TransferFund}/template`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        console.log(objList);
        // setBranchCode(objList)
        setLoading(false);
      }
    });
  };

  const getPaymentTypes = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.PaymentTypes}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        // console.log(objList);
        // setBranchCode(objList)
        setLoading(false);
      }
    });
  };

  //  function getClientDetails(clientId, officeId) {
  //     if (!clientId) return;

  //     BOM.FetchReqAction(
  //       { session },
  //       `${apiConfig.Clients}/${clientId}`,
  //       (err, res) => {
  //         if (!err && res?.imagePresent) {
  //           setClientPhoto(`${apiConfig.Clients}/${clientId}/images`);
  //         }
  //       },
  //     );

  //     if (officeId) {
  //       getVaultTemplate(officeId);
  //     }
  //   }

  function getAccountDetails(accountNo) {
    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }

    setLoading(true);
    const url = `${apiConfig.GetByAccountNo}/${accountNo}?associations=all`;

    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage || err);
        setLoading(false);
      } else {
        // getTemplate(res);
        // getClientDetails(res.clientId, res.officeId);
        const objList = res;
        console.log(objList);

        setSearchData({
          name: objList?.clientName ? objList?.clientName : "",
          branch: objList?.officeName ? objList?.officeName : "",
          fromAccount: objList?.accountNo ? objList?.accountNo : "",
          fromAccountType: objList?.depositType
            ? objList?.depositType?.value
            : "",
          currency: objList?.currency ? objList?.currency?.displayLabel : "",
        });

        setLoading(false);

        if (searchData === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          // setShowDetailsForm(false);
          setLoading(false);
          return;
        }
      }
    });
  }

  // const onSubmit = (values) => {
  //   const payload = {
  //     locale: "en",
  //     dateFormat: "dd MMMM yyyy",
  //     businesDate: values.date,
  //     branchCode: 1,
  //     batchUser: 1,
  //     batchStatus: vaultStatus,
  //     method: "POST",
  //     session,
  //   };

  //   console.log(payload);

  //   const url = `${apiConfig.BranchStatus}?officeId=1`;

  //   setLoading(true);
  //   BOM.FetchReqAction(payload, url, (err, res) => {
  //     if (err) {
  //       BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
  //       setLoading(false);
  //     } else {
  //       BOM.AlertMsg(cnt.SUCCESS, "Vault batch updated successfully");
  //       setLoading(false);
  //     }
  //   });
  // };

  const onSubmit = (values) => {
    console.log("Submitted values:", values);
    setLoading(true);
    setTimeout(() => {
      BOM.AlertMsg(cnt.SUCCESS, "Transfer submitted successfully");
      setLoading(false);
      form.resetFields();
    }, 2000);
  };

  const onSearch = () => {
    getAccountDetails(searchParam);
  };

  return (
    <MainLayout
      isEnableRightSidebar={false}
      pageItems={staticConfig.fundsTransferItems}
    >
      <TopContent
        pageTitle={labelConfig.manageFundsTransfer}
        //  createPageTitle={labelConfig.createMoneyMarketBond}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={loading}>
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Title level={5}>Transfering From Details</Title>
            {/* <Col span={12}>
                <Form.Item
                  label={labelConfig.accountNo}
                  name="accountNo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.accountNo),
                    },
                  ]}
                >
                  <Input.Search
                    style={{ width: 400, height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.accountNo,
                    )}
                    enterButton={
                      <Button
                        icon={<SearchOutlined />}
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(21, 204, 174, 1) 0%, rgba(79, 236, 160, 1) 100%)",
                          borderRadius: "0px 5px 5px 0px",
                          color: "black",
                          border: "none",
                        }}
                      />
                    }
                    onSearch={onSearch}
                  />
                </Form.Item>
              </Col> */}

            <Row style={{ marginBottom: 24 }}>
              <Col span={12}>
                <Form.Item
                  label={labelConfig.accountNo}
                  name="accountNo"
                  style={{ marginBottom: 0 }}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.accountNo,
                      )}
                      style={{ height: 44 }}
                      onPressEnter={onSearch}
                      allowClear
                    />
                    <Button
                      className="of-primaryBtnColor"
                      onClick={onSearch}
                      style={{ height: 44 }}
                    >
                      <SearchOutlined />
                    </Button>
                  </Space.Compact>
                </Form.Item>
              </Col>
            </Row>

            {searchData && (
              <Col span={24} style={{ marginBottom: 30 }}>
                <PreviewTable data={dataSections} />
              </Col>
            )}

            <Divider style={{ marginTop: 10 }} />
            <Title level={5}>Transferring To</Title>
            <Row style={{ marginBottom: 12 }} gutter={12}>
              <Col span={8}>
                <Form.Item
                  name="branch"
                  label={<Text strong>Branch</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Branch is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Select Branch"
                    options={branchOptions}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="client"
                  label={<Text strong>Client</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Client is required",
                    },
                  ]}
                >
                  <Input
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Enter Client Name or ID"
                    // onChange={handleDenominationChange}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="accountType"
                  label={<Text strong>Account Type</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Account type is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Select Account Type"
                    options={accountTypeOptions}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="paymentType"
                  label={<Text strong>Payment Type</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Payment type is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Select Payment Type"
                    options={paymentTypeOptions}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="account"
                  label={<Text strong>Account</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Account is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Select Account"
                    options={accountOptions}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="amount"
                  label={<Text strong>Amount</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Amount is required",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Enter Amount"
                    className="of-bold-disable-input"
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="transactionDate"
                  label={<Text strong>Transaction Date</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Transaction Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="Select date"
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="description"
                  label={<Text strong>Description</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Description is required",
                    },
                  ]}
                >
                  <TextArea
                    style={{ height: 88, resize: "none" }}
                    placeholder="Enter description"
                    className="of-bold-disable-input"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row style={{ marginTop: 24 }}>
              <Button
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                type="submit"
                className="of-primaryBtnColor"
                onClick={onSubmit}
              >
                Submit
              </Button>
            </Row>
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(FundsTransfer);
